export default __webpack_public_path__ + "static/media/ChadIcon.2f9c5c22.png";